import { render, staticRenderFns } from "./AffPayoutCapLimit.vue?vue&type=template&id=2dead0c6"
import script from "./AffPayoutCapLimit.vue?vue&type=script&lang=js"
export * from "./AffPayoutCapLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports